<script lang="ts">
  import { QrCodeService } from '../../services/QrCodeService';

  interface Props {
    text: string;
    size?: string | number;
    class?: string;
  }

  const { text, size = '12rem', class: className }: Props = $props();

  const qr = $derived.by(() => {
    try {
      return QrCodeService.generateSvgPath(text);
    } catch {
      return null;
    }
  });

  const sizeStyle = $derived(typeof size === 'number' ? `${size.toString()}px` : size);
</script>

{#if qr !== null}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${qr.viewBoxSize.toString()} ${qr.viewBoxSize.toString()}`}
    style:width={sizeStyle}
    style:height={sizeStyle}
    style:max-width="100%"
    style:aspect-ratio="1 / 1"
    class={className}>
    <rect width="100%" height="100%" fill="#ffffff" />
    <path d={qr.path} fill="#000000" />
  </svg>
{/if}
